import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.trouble-tickets-gesendete';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTroubleTicketsGesendeteEffects {

    TroubleTicketsGesendete$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_TROUBLE_TICKETS_GESENDETE),
        mergeMap((x: ac.GetTroubleTicketsGesendeteAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getTroubleTicketsGesendete().pipe(
                map((result: any) => {
                    return new ac.GetTroubleTicketsGesendeteErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetTroubleTicketsGesendeteFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketQueryService);
        }
        return this.service;
    }
}
